/**
 * Wraps dismissible announcement bar sections and all non-dismissible bars below
 * them in a CSS grid stack so only one bar height is reserved in the header group.
 *
 * @returns {boolean} Whether any stack was created or updated
 */
function setupAnnouncementBarStacks() {
  if (window.Shopify?.designMode) return false;

  const headerGroup = document.querySelector('#header-group');
  if (!headerGroup) return false;

  const headerSection = headerGroup.querySelector('.header-section');
  let updated = false;

  const announcementSections = [...headerGroup.children].filter(
    (element) => element instanceof HTMLElement && element.classList.contains('announcement-bar-section')
  );

  for (const section of announcementSections) {
    if (section.closest('.announcement-bar-stack')) continue;
    if (!section.querySelector('.announcement-bar--dismissible')) continue;

    /** @type {HTMLElement[]} */
    const baseSections = [];
    let sibling = section.nextElementSibling;

    while (sibling && sibling !== headerSection) {
      if (sibling instanceof HTMLElement && sibling.classList.contains('announcement-bar-section')) {
        if (sibling.querySelector('.announcement-bar--dismissible')) break;
        if (!sibling.closest('.announcement-bar-stack')) {
          baseSections.push(sibling);
        }
      }

      sibling = sibling.nextElementSibling;
    }

    if (baseSections.length === 0) continue;

    const stack = document.createElement('div');
    stack.className = 'announcement-bar-stack';
    stack.dataset.announcementStack = '';

    section.parentNode?.insertBefore(stack, section);
    stack.appendChild(section);

    for (const baseSection of baseSections) {
      stack.appendChild(baseSection);
    }

    updated = true;
  }

  if (updated) {
    document.dispatchEvent(new CustomEvent('announcement-bar-stack:updated'));
  }

  return updated;
}

window.setupAnnouncementBarStacks = setupAnnouncementBarStacks;
